import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';

import { useAppSelector } from 'js/store/hooks';
import { ReactComponent as IconOffline } from 'imgs/svg-icons/IconOffline.svg';
import isElectron from 'js/shared/helpers/isElectron';

import Toast from '../Toast';

const OfflineWarning = () => {
  const isOnline = useAppSelector(state => state.network.isOnline);
  const [position, setPosition] = useState<'bottom-left' | 'bottom-right'>('bottom-right');

  useEffect(() => {
    if (!isOnline) {
      const handleMouseOver = () => {
        if (position === 'bottom-left') {
          setPosition('bottom-right');
        } else {
          setPosition('bottom-left');
        }
      };

      const toastId = toast.custom(
        () => (
          <Toast
            title="You are currently working in offline mode"
            description="Return online to save changes."
            onMouseEnter={handleMouseOver}
            icon={<IconOffline />}
          />
        ),
        {
          richColors: true,
          dismissible: false,
          position,
          duration: Infinity
        }
      );

      return () => {
        toast.dismiss(toastId);
      };
    }
  }, [isOnline, position]);

  useEffect(() => {
    const warnAboutUnsavedChanges = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };

    if (!isOnline && !isElectron()) {
      window.addEventListener('beforeunload', warnAboutUnsavedChanges);

      return () => {
        window.removeEventListener('beforeunload', warnAboutUnsavedChanges);
      };
    }
  }, [isOnline]);

  return null;
};

export default OfflineWarning;
